import { render } from "./SectionVetement.vue?vue&type=template&id=b2fa27e0"
import script from "./SectionVetement.vue?vue&type=script&lang=js"
export * from "./SectionVetement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__